export * from './trademark-data.helper';
